import { render, staticRenderFns } from "./MyHisTaskList.vue?vue&type=template&id=0acb3dd5&scoped=true&"
import script from "./MyHisTaskList.vue?vue&type=script&lang=js&"
export * from "./MyHisTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acb3dd5",
  null
  
)

export default component.exports